import globalActions from '@actions';

const initialState = {
  error: null
};

const ErrorReducer = (state = initialState, action) => {
  switch (action.type) {
    case globalActions.FETCH_RESOURCE_FAIL.type:
      return { ...state, error: action.error };

    default:
      return state;
  }
};

export default ErrorReducer;
